import { plainToClass } from 'class-transformer';
import {
  API_CLIENT_CONTACT_FIND_ALL,
  API_CLIENT_CONTACT_FIND_ONE,
  API_CLIENT_CONTACT_CREATE,
  API_CLIENT_CONTACT_DELETE,
  API_CLIENT_CONTACT_UPDATE
} from '../api.routes';
import { BaseApi } from './base.api';
import { FindAllResponse } from '../types';
import { ClientContactDto } from '../dto';

export class ClientContactApi extends BaseApi {
  /**
   * Find all
   */
  public findAll(params): Promise<FindAllResponse<ClientContactDto>> {
    return this.httpClient
      .get(API_CLIENT_CONTACT_FIND_ALL, { params })
      .then(({ data }) => {
        return {
          ...data,
          items: plainToClass(ClientContactDto, data.items)
        };
      });
  }

  /**
   * Find one
   * @param uuid
   */
  public findOne(uuid: string): Promise<ClientContactDto> {
    return this.httpClient
      .get(API_CLIENT_CONTACT_FIND_ONE, { pathParams: { uuid } })
      .then(({ data }) => {
        return plainToClass(ClientContactDto, data);
      });
  }

  /**
   * Create
   * @param data
   */
  public create(data): Promise<ClientContactDto> {
    return this.httpClient
      .post(API_CLIENT_CONTACT_CREATE, data)
      .then(({ data }) => {
        return plainToClass(ClientContactDto, data);
      });
  }

  /**
   * Update
   * @param data
   */
  public update(data): Promise<ClientContactDto> {
    return this.httpClient
      .put(API_CLIENT_CONTACT_UPDATE, data)
      .then(({ data }) => {
        return plainToClass(ClientContactDto, data);
      });
  }

  /**
   * Delete
   * @param uuid
   */
  public delete(uuid): Promise<void> {
    return this.httpClient.delete(API_CLIENT_CONTACT_DELETE, {
      pathParams: { uuid }
    });
  }
}
